export default {
  isOpen(state) {
    return state.open;
  },

  width(state) {
    return state.width;
  },

  /** Pedido pendente de nova conversa, vindo de outra tela. */
  request(state) {
    return state.request;
  },

  /** Quanto o conteúdo do app precisa recuar para o painel não cobri-lo. */
  contentOffset(state) {
    return state.open ? state.width : 0;
  }
};
